// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"Logo--next-sr-only--Rz8GfUa","logo":"Logo--logo--3ZywIgz"};